/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Note } from "../model"
// @ts-ignore
import type { SaveNoteRequest } from "../model"
/**
 * NoteResourceV2Api - axios parameter creator
 */
export const NoteResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get active note by project id
     * @param {string} projectId
     * @param {string} userId
     * @param {string} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentNote: async (
      projectId: string,
      userId: string,
      userName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getCurrentNote", "projectId", projectId)
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getCurrentNote", "userId", userId)
      // verify required parameter 'userName' is not null or undefined
      assertParamExists("getCurrentNote", "userName", userName)
      const localVarPath = `/v2.0/note/current/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      if (userId != null) {
        localVarHeaderParameter["userId"] = String(userId)
      }
      if (userName != null) {
        localVarHeaderParameter["userName"] = String(userName)
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note by id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNote: async (noteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getNote", "noteId", noteId)
      const localVarPath = `/v2.0/note/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update note
     * @param {string} userId
     * @param {string} userName
     * @param {SaveNoteRequest} saveNoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNote: async (
      userId: string,
      userName: string,
      saveNoteRequest: SaveNoteRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("updateNote", "userId", userId)
      // verify required parameter 'userName' is not null or undefined
      assertParamExists("updateNote", "userName", userName)
      // verify required parameter 'saveNoteRequest' is not null or undefined
      assertParamExists("updateNote", "saveNoteRequest", saveNoteRequest)
      const localVarPath = `/v2.0/note`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      if (userId != null) {
        localVarHeaderParameter["userId"] = String(userId)
      }
      if (userName != null) {
        localVarHeaderParameter["userName"] = String(userName)
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saveNoteRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * NoteResourceV2Api - functional programming interface
 */
export const NoteResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NoteResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get active note by project id
     * @param {string} projectId
     * @param {string} userId
     * @param {string} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCurrentNote(
      projectId: string,
      userId: string,
      userName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentNote(
        projectId,
        userId,
        userName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NoteResourceV2Api.getCurrentNote"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note by id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNote(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNote(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NoteResourceV2Api.getNote"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update note
     * @param {string} userId
     * @param {string} userName
     * @param {SaveNoteRequest} saveNoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateNote(
      userId: string,
      userName: string,
      saveNoteRequest: SaveNoteRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateNote(
        userId,
        userName,
        saveNoteRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NoteResourceV2Api.updateNote"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * NoteResourceV2Api - factory interface
 */
export const NoteResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NoteResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Get active note by project id
     * @param {NoteResourceV2ApiGetCurrentNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentNote(
      requestParameters: NoteResourceV2ApiGetCurrentNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .getCurrentNote(
          requestParameters.projectId,
          requestParameters.userId,
          requestParameters.userName,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note by id
     * @param {NoteResourceV2ApiGetNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNote(
      requestParameters: NoteResourceV2ApiGetNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .getNote(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update note
     * @param {NoteResourceV2ApiUpdateNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNote(
      requestParameters: NoteResourceV2ApiUpdateNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .updateNote(
          requestParameters.userId,
          requestParameters.userName,
          requestParameters.saveNoteRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getCurrentNote operation in NoteResourceV2Api.
 */
export interface NoteResourceV2ApiGetCurrentNoteRequest {
  readonly projectId: string

  readonly userId: string

  readonly userName: string
}

/**
 * Request parameters for getNote operation in NoteResourceV2Api.
 */
export interface NoteResourceV2ApiGetNoteRequest {
  readonly noteId: string
}

/**
 * Request parameters for updateNote operation in NoteResourceV2Api.
 */
export interface NoteResourceV2ApiUpdateNoteRequest {
  readonly userId: string

  readonly userName: string

  readonly saveNoteRequest: SaveNoteRequest
}

/**
 * NoteResourceV2Api - object-oriented interface
 */
export class NoteResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Get active note by project id
   * @param {NoteResourceV2ApiGetCurrentNoteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCurrentNote(
    requestParameters: NoteResourceV2ApiGetCurrentNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return NoteResourceV2ApiFp(this.configuration)
      .getCurrentNote(
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.userName,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note by id
   * @param {NoteResourceV2ApiGetNoteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getNote(
    requestParameters: NoteResourceV2ApiGetNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return NoteResourceV2ApiFp(this.configuration)
      .getNote(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update note
   * @param {NoteResourceV2ApiUpdateNoteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateNote(
    requestParameters: NoteResourceV2ApiUpdateNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return NoteResourceV2ApiFp(this.configuration)
      .updateNote(
        requestParameters.userId,
        requestParameters.userName,
        requestParameters.saveNoteRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
